export default [
	{
		path: '/dabvent',
		component: () => import(/* webpackChunkName: "dabvent" */ './Index.vue')
	}
]
